/**
 * React Query mutation hook for updating user refill settings
 */

import { useMutation, useQueryClient } from '@tanstack/react-query'
import { v1UsersApi, RefillSettingsRequest, RefillSettingsResponse } from '../api'
import { toast } from 'sonner'

interface UpdateRefillSettingsVariables extends RefillSettingsRequest {
  userId: string
}

export function useUpdateRefillSettings() {
  const queryClient = useQueryClient()

  return useMutation<RefillSettingsResponse, Error, UpdateRefillSettingsVariables>({
    mutationFn: ({ userId, ...settings }: UpdateRefillSettingsVariables) =>
      v1UsersApi.updateRefillSettings(userId, settings),

    onSuccess: (data) => {
      const message = data.autoRefillEnabled
        ? `Auto-refill enabled: ${data.refillAmount} tokens every ${data.refillIntervalValue} ${data.refillIntervalUnit}`
        : 'Auto-refill disabled'

      toast.success('Refill settings updated', {
        description: message
      })

      // Invalidate users list and specific user queries
      queryClient.invalidateQueries({ queryKey: ['v1', 'users'] })
    },

    onError: (error: any) => {
      const message = error.response?.data?.detail || error.message || 'Failed to update refill settings'
      toast.error('Update failed', {
        description: message
      })
    }
  })
}
